import { useContext } from 'react';

import { BasketPreviewContext } from '@/context/basketPreviewContext';

export function useBasketPreviewContext() {
  return useContext(BasketPreviewContext);
}
